<template>
  <!--srcviewscompanydetailsvuehtmlStart-->
  <!-- 详情 -->
  <div
    id="defaultId1"
    class="trade-theme"
    name="header"
    ref="scrollContainer"
    @scroll="handleScroll"
  >
    <Headers></Headers>
    <content_view v-if="!Compare" id="gc95c2" ref="contentView">
      <template id="ce3846" slot="header">
        <div id="cdd8de" class="uVNPU6H">
          <tools
            id="c46180"
            class="u35ff8"
            :UpdateStatus="UpdateStatus"
            :config="$store.state.app.toolsConfig"
            @clickMenu="clickMenu"
            ref="tools"
          >
          </tools>
        </div>
      </template>
      <template id="c3b8e6" slot="details_view">
        <div id="g30b5a" class="trade_middle_top">
          <!-- style="width: 43.5%" -->
          <div id="ga36b2" class="c u4f5b" style="width: 55%">
            <el-tooltip
              :disabled="
                HsCodeObject?.hsCodeDescription?.length < 200 ||
                HsCodeObject?.hsCodeDescription == null
              "
              :content="HsCodeObject.hsCodeDescription"
              placement="top"
            >
              <div class="hsDes">
                {{ HsCodeObject.hsCode }}-{{ HsCodeObject.hsCodeDescription }}
              </div>
            </el-tooltip>
            <div class="flex_center_start_box margin-top20">
              <span class="Updateyear font16"
                >{{ $t("SearchTrade.LastUpdate") }} :
                {{ HsCodeObject.updateYear }}</span
              >
            </div>
          </div>

          <div style="width: 35%; height: 100%" class="borderLIne">
            <div id="g1d5a8" class="trade_middle_top_pro">
              <div class="HsCode">
                {{ $t("SearchTrade.ProductCode") }} :
                {{ HsCodeObject.productCode }}
              </div>
            </div>

            <el-tooltip
              :disabled="
                HsCodeObject?.productCodeDescription?.length < 180 ||
                HsCodeObject?.productCodeDescription == null
              "
              :content="HsCodeObject.productCodeDescription"
              placement="top"
              effect="light"
            >
              <div class="hsDestwo">
                {{ $t("SearchTrade.ProductDescription") }} :
                {{ HsCodeObject.productCodeDescription }}
              </div>
            </el-tooltip>
          </div>
          <div style="width: 10%; height: 100%">
            <div id="g1d5a8" class="u83191center">
              <div
                :class="
                  HsCodeObject.productSanction == 'Punish'
                    ? 'IsSactionActive '
                    : 'IsSactionActive'
                "
              >
                <img
                  v-if="HsCodeObject.productSanction == 'Punish'"
                  src="../../assets/images/ProcutesError.png"
                  alt=""
                />
                <img
                  v-else
                  src="../../assets/images/ProcutesSuccess.png"
                  alt=""
                />
              </div>
            </div>
            <div id="g1d5a8" class="u83191center">
              <div
                class="hsDestwo"
                style="text-align: center"
                v-if="HsCodeObject.productSanction == 'Punish'"
              >
                {{ $t("SearchTrade.Sanctions") }} : Current
              </div>
              <div class="hsDestwo" style="text-align: center" v-else>
                {{ $t("SearchTrade.Sanctions") }} : Clear
              </div>
            </div>
          </div>
        </div>
        <div id="g29da1" class="trade_bottom_cont">
          <div id="g06fa7" class="ue896e">
            <ul id="ga9199" class="ufb44d">
              <div id="g251bf"></div>
              <li
                id="ga557d"
                @click="openUrl(item, '')"
                v-for="(item, index) in breadcrumbBar"
                :key="index"
                v-show="item.isShow"
                :class="tab1ActiveName == item.id ? 'bread_active' : ''"
                class="trade_tab_item"
              >
                <div
                  class="textu99b63"
                  :class="tab1ActiveName == item.id ? 'bread_active2' : ''"
                >
                  {{ item.screenName }}
                </div>
              </li>
            </ul>
          </div>
          <div
            id="g599f6"
            v-show="isShowMoreMark"
            class="trade_midlle_bottom mb10"
          >
            <div
              id="gfff13"
              class="trade_midlle_bottom_cont"
              v-if="markTotalList.length > 0"
              :class="[isNoShowTab2 != 'showMark' ? 'mt0' : 'mt0']"
            >
              <div
                v-for="(item, index) in markTotalList"
                :key="index"
                style="flex: 1"
              >
                <gui_mark_total
                  :isTradeProduct="true"
                  :MoudeImg="'images/tradejiugonge.png'"
                  id="g9eda6"
                  class="trade_midlle_bottom_item"
                  :label="item.name"
                  :total="item.num"
                  v-if="item.num != '-'"
                >
                </gui_mark_total>
              </div>
            </div>
          </div>
          <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
            <button class="showBackToTop">
              <i class="iconfont icon-arrow-top" style="color: #fff"></i>
            </button>
          </div>

          <div id="g1e372" class="u0c804">
            <router-view
              :companyBaseRoute="company"
              id="cb02bf"
              ref="route"
              @UpdatamarkTotalList="childUpdatamarkTotalList"
            >
            </router-view>
          </div>
        </div>
      </template>
    </content_view>
    <Suo
      :suoClose="Update"
      @closeCloseDialog="clossuoDialog($event)"
      @closeCloseDialog1="clossuoDialog1($event)"
    ></Suo>

    <el-dialog
      :visible.sync="hasPrivilege"
      center
      :close-on-click-modal="true"
      @close="chasPrivilegeDialog"
      custom-class="dialog_normalsuo dialog_normalpower"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center">
            <img
              class="powerdengpao"
              src="@/assets/images/powerdengpao.png"
              alt=""
            />
          </div>
          <div class="detail_cont_text">
            {{ $t("Home.detailconttext") }}
          </div>
        </div>
      </div>
      <div class="flex_center">
        <!-- <el-button
          class="btn_export btn_exportCCC"
          @click="hasPrivilege = false"
          >{{ $t("SearchTrade.OK") }}</el-button
        > -->
        <el-button
          class="btn_export"
          @click="
            $router.push({
              path: '/index/addCredit',
            })
          "
          >{{ $t("Home.Subscribe") }}</el-button
        >
      </div>
    </el-dialog>
    <PermissionDialog></PermissionDialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import Headers from "@/views/newLayout/header.vue";
import PermissionDialog from "@/components/power/PermissionDialog.vue";
import { mixins1 } from "@/mixins/index";
import content_view from "../layout/content_view.vue";
import gui_tabs from "../../components/gui_tabs/gui_tabs.vue";
import gui_tab_item from "../../components/gui_tabs/gui_tab_item.vue";
import gui_collapse from "../../components/gui_collapse/gui_collapse.vue";
import gui_checkbox from "../../components/gui_checkbox/gui_checkbox.vue";
import gui_scroll_x from "../../components/gui_scroll_x/gui_scroll_x.vue";
import gui_link_content from "../../components/gui_link_content/gui_link_content.vue";
import * as echarts from "echarts/core";
import { menuRouter, tabList } from "../../config/index.js";
import { getProductProfile, queryProductDetail } from "@/api/companyApi.js";
import gui_mark_total from "../../components/gui_mark_total/gui_mark_total.vue";
import tools from "@/views/layout/tools.vue";
import Suo from "./list/UpdateDialog.vue";
import ReLogin from "../../components/ReLogin.vue";
import detailecomparePrioduct from "./TradeProduct/detailecomparePrioduct.vue";
import { formatNum } from "@/views/company/details/Background/utils";

//importEnd
import {
  downloadOnlinePdf,
  gettabList,
  whetherDeductPoints,
  getTabListOneLayer,
} from "@/api/userApi";
export default {
  name: "",
  mixins: [mixins1],
  props: {},
  watch: {
    $route(to, from) {
      // 在路由变化时执行的代码
      if (to.name == "businessActivitiesimport&Export") {
        this.tab2ActiveName = to.query.idpower;
      }
    },
  },
  mounted() {
    this.$store.state.app.toolsConfig.creditAssessment.isShow = false;
    this.$store.state.app.toolsConfig.dataAnalysis.isShow = false;
    this.$store.state.app.toolsConfig.customPortfolio.isShow = false;
    this.$store.state.app.toolsConfig.print.isShow = false;
    this.$store.state.app.toolsConfig.riskScanning.isShow = false;
    this.$store.state.app.toolsConfig.sort.isShow = false;
    this.$store.state.app.toolsConfig.sort.isActive = false;
    this.gettabList();
    this.setThemeColor();
  },
  created() {
    this.getCompanySnaplist();
    window.addEventListener("scroll", this.handleScroll);
    this.whetherDeductPointsDetail();
    this.setToolsfalse();
  },
  beforeUnmount() {
    // 移除页面滚动事件的监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  active() {},

  components: {
    Headers,
    PermissionDialog,
    Suo,
    tools,
    gui_mark_total,
    content_view,
    gui_tabs,
    gui_tab_item,
    gui_collapse,
    gui_checkbox,
    gui_scroll_x,
    gui_link_content,
    ReLogin,
    detailecomparePrioduct,
  },

  data() {
    return {
      showBackToTop: false,
      reLoginVis: false,
      UpdateStatus: 0,
      Compare: false,
      ReportError: false,
      powerToReportErrorStatus: false,
      Update: false,
      Download: false,
      hasPrivilege: false,

      // option2
      company: null,
      compareList: [],

      HsCodeObject: {
        hsCode: "",
        hsCodeDescription: "",
        productCode: "",
        productCodeDescription: "",
      },
      // option1

      // isShowMenu
      isShowMenu: true,

      // toolsConfig
      toolsConfig: {
        menu: {
          isShow: true,
          isActive: false,
        },

        filter: {
          isShow: false,
          isActive: false,
        },

        select: {
          isShow: true,
          isActive: false,
        },

        edit: {
          isShow: true,
          isActive: false,
        },

        sort: {
          isShow: true,
          isActive: false,
        },

        collect: {
          isShow: true,
          isActive: false,
        },

        saved: {
          isShow: true,
          isActive: false,
        },

        compare: {
          isShow: true,
          isActive: false,
        },

        export: {
          isShow: true,
          isActive: false,
        },

        download: {
          isShow: true,
          isActive: false,
        },

        update: {
          isShow: true,
          isActive: false,
        },

        reportError: {
          isShow: true,
          isActive: false,
        },

        riskScanning: {
          isShow: true,
          isActive: false,
        },
        creditAssessment: {
          isShow: true,
          isActive: false,
        },
        dataAnalysis: {
          isShow: true,
          isActive: false,
        },
        customPortfolio: {
          isShow: true,
          isActive: false,
        },
        print: {
          isShow: true,
          isActive: false,
        },
        share: {
          isShow: true,
          isActive: false,
        },
      },
      // star
      star: false,
      // isShowMoreMark
      isShowMoreMark: true,
      // markList
      markList: [],
      // breadcrumbBar
      // breadcrumbBar: tabList,
      breadcrumbBar: [],
      // tab1ActiveName
      tab1ActiveName: "Business Activities",
      // isNoShowTab2
      isNoShowTab2: false,
      hasPrivilege: false,
      // 背景样式
      tab2BkStyle: {
        width: "",
        height: "",
        left: "",
        top: "",
        display: "block",
      },
      // tab2_list
      tab2_list: ["Snapshot", "Profile", "Ownership"],
      // tab2ActiveName
      tab2ActiveName: "Snapshot",
      // markTotalList
      markTotalList: [],
      CreditScore: "",
      // srcviewscompanydetailsvueDataEnd
    };
  },
  methods: {
    handleScroll() {
      // 判断页面滚动距离是否超过200px，更新showBackToTop的值
      const scrollTop = this.$refs.scrollContainer.scrollTop;
      // console.log(`window.pageYOffset`, window.pageYOffset);
      this.showBackToTop = scrollTop > 390;
    },
    scrollToTop() {
      const container = this.$refs.scrollContainer; // 使用 ref 获取容器
      container.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 使用scrollTo()方法将页面滚动到顶部
      // window.scrollTo({
      //     top: 0,
      //     behavior: 'smooth',
      // });
    },
    whetherDeductPointsDetail() {
      if (this.$route.query.id3a) {
        whetherDeductPoints({
          companyAaaid: this.$route.query.id3a,
        }).then((res) => {
          this.UpdateStatus = res.data.status;
          if (this.UpdateStatus == 6 || this.UpdateStatus == 2) {
            this.toolsConfig.update.isActive = false;
          }
        });
      }
    },
    gettabList() {
      getTabListOneLayer({
        hsCode: this.$route.query.id3a,
        moduleType: 8,
      }).then((res) => {
        let routerName = this.$route.name;

        if (res.code == 200) {
          this.breadcrumbBar = res.data;
          let moduleId =
            res.data.find((item) => routerName.includes(item.name))?.id || null;
          this.tab1ActiveName = moduleId;
          if (moduleId) {
            getTabListOneLayer({
              hsCode: this.$route.query.id3a,
              moduleId: moduleId,
            }).then((res) => {
              this.tab2_list = res.data;
              let tab2ActiveName =
                res.data.find((item) => routerName.includes(item.name))?.id ||
                null;
              this.tab2ActiveName = tab2ActiveName;
            });
          }
          let arr = [];
          res.data.map((item, index) => {
            // || item.name == 'marketAnalysis'
            if (item.name == "creditOpinion") {
              arr.push({
                id: item.name,
                name: item.screenName,
                children:
                  item.name == "creditOpinion"
                    ? [{ name: "tab2", id: "list" }]
                    : [
                        {
                          name: "tab2",
                          id: "list",
                          children: [],
                        },
                      ],
                isShow: item.isShow,
                //   item.hasPrivilege
                hasPrivilege: true,
                isNoShowTab2:
                  item.name == "creditOpinion" ? "noShowAll" : "showMark",
              });
            } else {
            }
          });
        }
      });
    },
    //关闭report弹窗
    closeDialog(value) {
      this.ReportError = value;
    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false;
    },
    clossuoDialog(value) {
      this.Update = value;
    },
    clossuoDialog1(value) {
      // this.suopower = value;
    },
    CompareShow(val) {
      this.Compare = false;
    },

    childUpdatamarkTotalList(value) {
      this.isShowMoreMark = value;
      // this.markTotalList = value
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
    
    // insertMethod
    // srcviewscompanydetailsvueMethodStart
    // initTab
    getCompanySnaplist() {
      const id3a = this.$route.query.id3a;
      getProductProfile({
        hsCode: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            this.HsCodeObject = res.data;
            sessionStorage.setItem(
              "hsCodeDescription",
              this.HsCodeObject?.hsCodeDescription,
            );
            document.title = this.HsCodeObject?.hsCodeDescription;
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
      queryProductDetail({
        hsCode: id3a,
      })
        .then((res) => {
          if (res.code == 200) {
            console.log(res.data);
            this.markTotalList = [
              {
                name: this.$t("SearchTrade.TotalImports"),
                num: formatNum(res.data.importAmount) ,
              },
              {
                name: this.$t("SearchTrade.TotalExports"),
                num:  formatNum(res.data.exportAmount),
              },
              {
                name: this.$t("SearchTrade.TotalImportWeight"),
                num:  formatNum(res.data.importWeight),
              },
              {
                name: this.$t("SearchTrade.TotalExportWeight"),
                num:  formatNum(res.data.exportWeight),
              },
              {
                name: this.$t("SearchTrade.NumberofSuppliers"),
                num:  formatNum(res.data.numberOfSuppliers),
              },
              {
                name: this.$t("SearchTrade.NumberofBuyers"),
                num: formatNum(res.data.numberOfBuyers),
              },
              {
                name: this.$t("SearchTrade.NumberofOriginCountries"),
                num: formatNum(res.data.numberOfOrigins),
              },
              {
                name: this.$t("SearchTrade.NumberofDestinationCountries"),
                num: formatNum(res.data.numberOfDestinations),
              },
            ];
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    initTab() {
      let routes = {};
      this.breadcrumbBar.forEach((item) => {
        item.children.forEach((item2) => {
          let obj = {
            tab1: item.id,
            tab2: item2.id,
            isNoShowTab2: item.isNoShowTab2,
            tab2List: item.children,
          };
          routes[item.id + item2.id] = obj;
        });
      });
      let routerName = this.$route.name;

      this.tab1ActiveName = routes[routerName].tab1;
      this.tab2ActiveName = routes[routerName].tab2;
      this.tab2_list = routes[routerName].tab2List;

      let markTotal = this.tab2_list.find(
        (item) => item.id == this.tab2ActiveName,
      );

      let isNoShowTab2 = routes[routerName].isNoShowTab2;

      if (isNoShowTab2) {
        this.isNoShowTab2 = isNoShowTab2;
      } else {
        this.isNoShowTab2 = false;
      }
    },

    // clickMenu 控制详情
    clickMenu(name, data) {
      switch (name) {
        case "menu":
          this.$store.dispatch("app/toggleMenu", !this.$store.state.app.isMenu);
          break;
        case "select":
          this.$nextTick(() => {
            if (this.$refs.route.isOpenSlct) {
              this.$refs.route.isOpenSlct = false;
              this.$refs.route.isOpenSlct = false;
            } else {
              this.$refs.route.isOpenSlct = "Select";
              this.$refs.route.isOpenSlct = "Select";
            }
          });
          break;
        case "Update":
          this.Update = true;

          break;
        case "download":
          this.Download = true;
          downloadOnlinePdf(this.$route.query.id3a)
            .then((res) => {
              const binaryData = [];
              binaryData.push(res);
              let pdfUrl = window.URL.createObjectURL(
                new Blob(binaryData, { type: "application/pdf" }),
              );
              window.open(pdfUrl, "_blank");
            })
            .catch((err) => {
              this.reLoginVis = String(err).includes("403");
            });
          break;
        case "Compare":
          this.$nextTick(() => {
            if (this.$refs.route.Compare) {
              this.$refs.route.Compare = false;
            } else {
              this.$refs.route.Compare = true;
            }
          });
          break;

        case "Report":
          this.ReportError = true;
          this.powerToReportErrorStatus = true;
          break;

        case "edit":
          break;
      }
    },

    openUrl(tab1Name, tab2Name) {
      let SACode1 = "";

      if (tab1Name?.hasPrivilege || tab2Name?.hasPrivilege) {
        if (!tab1Name) {
          let tab1NameVal = this.breadcrumbBar.find(
            (item) => item.id == this.tab1ActiveName,
          )?.name;
          let tab2NameVal = tab2Name.name;
          this.tab2ActiveName = tab2Name.id;

          this.$router.push({
            name: "TradeProductDetails" + tab1NameVal + tab2NameVal,
            params: {
              id: this.$route.params.id,
              idpower: tab2Name?.id,
            },
            query: {
              id3a: this.$route.query.id3a,
              companyCountry: this.company.base.countryFlag,
              SACode1: SACode1,
              idpower: tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
              companyName: this.$route.query.companyName,
              Tradechannel: this.$route.query.Tradechannel,
              Moudles: "Trade",
            },
          });
        } else {
          this.tab1ActiveName = tab1Name?.id;
          getTabListOneLayer({
            aaaId: this.$route.query.id3a,
            moduleId: tab1Name?.id,
          }).then((res) => {
            if (res.data.length > 0) {
              this.tab2_list = res.data.filter((item) => item.isShow == true);
              if (this.tab2_list.length > 0) {
                this.isNoShowTab2 = "";
                this.tab2ActiveName = this.tab2_list[0]?.id;
                this.$router.push({
                  name:
                    "TradeProductDetails" +
                    tab1Name.name +
                    this.tab2_list[0]?.name,
                  params: {
                    id: this.$route.params.id,
                    idpower: tab2Name?.id,
                  },
                  query: {
                    id3a: this.$route.query.id3a,
                    companyCountry: this.company.base.countryFlag,
                    SACode1: SACode1,
                    idpower:
                      tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                    companyName: this.$route.query.companyName,
                    Moudles: "Trade",
                    Tradechannel: this.$route.query.Tradechannel,
                  },
                });
              }
            } else {
              if (tab1Name?.name == "creditOpinion") {
                this.isNoShowTab2 = "noShowAll";
              } else if (tab1Name?.name == "marketAnalysis") {
                this.isNoShowTab2 = "showMark";
              }
              this.tab2_list =
                tab1Name?.name == "creditOpinion"
                  ? [{ name: "tab2", id: "list" }]
                  : this.$router.push({
                      name: "TradeProductDetails" + tab1Name.name,
                      params: {
                        id: this.$route.params.id,
                        idpower: tab2Name?.id,
                      },
                      query: {
                        id3a: this.$route.query.id3a,
                        companyCountry: this.$route.query.companyCountry,

                        SACode1: SACode1,
                        idpower:
                          tab2Name.id == undefined ? tab1Name?.id : tab2Name.id,
                        companyName: this.$route.query.companyName,
                        Tradechannel: this.$route.query.Tradechannel,
                        Moudles: "Trade",
                      },
                    });
            }
          });
        }
      } else {
        this.hasPrivilege = true;
      }
    }, // 离开悬浮
    leaveTab2(event) {
      this.tab2BkStyle.display = `none`;
    }, // 悬浮tab2监听
    overTab2(e) {
      let event = e;
      const rect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentNode.getBoundingClientRect();
      this.tab2BkStyle.width = `${rect.width}px`;
      this.tab2BkStyle.height = `${rect.height}px`;
      this.tab2BkStyle.left = `${rect.left - parentRect.left}px`;
      this.tab2BkStyle.top = `${rect.top - parentRect.top}px`;
      this.tab2BkStyle.display = `block`;
    }, // setThemeColor
    setThemeColor() {
      this.$store.dispatch("app/setThemColor", "#009EA7");
      this.$store.dispatch("app/setSearchType", "TradeDetail");
    },
    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "riskScanning",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "creditAssessment",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "dataAnalysis",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "customPortfolio",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "print",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // srcviewscompanydetailsvueMethodEnd
  },
  computed: {},
};
</script>
<style>
.uVNPU6H {
  width: 100%;
}

.u35ff8 {
  width: 100%;
  overflow: hidden;
}

.trade_middle_top {
  display: flex;
  min-height: 286px;
  padding-top: 20px;
  padding-left: 70px;
  padding-right: 70px;
  background-color: #009ea7;
}

.u4f5b {
  display: block;
  justify-content: flex-start;
  align-items: flex-start;
  border-color: rgb(172, 201, 24);
  color: rgb(255, 255, 255);
}

.uc4421 {
  color: rgb(255, 255, 255);
  margin-top: 0rem;
  margin-bottom: 0rem;
  margin-left: 0rem;
  margin-right: 0rem;
  padding-top: 0rem;
  padding-left: 0rem;
  padding-right: 0rem;
  padding-bottom: 0rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uc4421_text {
  font-size: 2.57rem;
  font-family: "Arial Bold";
  overflow: hidden;
  text-overflow: ellipsis;
}

.u0e1f6 {
  display: flex;
  align-items: center;
  margin-top: 1.28em;
  margin-bottom: 0.85rem;
  flex-direction: row;
}

.uc6a2b {
  width: 3.5714285714rem;
  height: 2.14285714rem;
  margin-right: 0.71rem;
}

.ubb08b {
  color: rgb(255, 255, 255);
  font-size: 1.285714rem;
  height: auto;
  overflow-y: auto;
  min-width: 40%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u5b01d {
  color: rgb(255, 255, 255);
  margin-top: 1.4285714285714286rem;
  font-size: 1.285714rem;
}

.trade_middle_top_pro {
  display: flex;
}

.uboa8Fv {
  display: flex;
}

.u07ca9 {
  display: inline-block;
  margin-left: -1.4rem;
  margin-right: 1.4285714285714286rem;
  box-sizing: content-box;
}

.u61637 {
  border-color: rgb(53, 24, 201);
  overflow-y: auto;
}

.u91cf9 {
  display: inline-block;
  border-color: rgb(255, 255, 255);
  background-color: rgb(254, 254, 254);
  padding: 0.42857142857142855rem;
  color: rgb(18, 144, 201);
  margin-right: 0.42rem;
  margin-bottom: 0.42rem;
  font-size: 1.285714rem;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.u9KBSet {
  transform: rotate(1deg);
}
.trade_bottom_cont {
  margin-top: -100px;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  z-index: 99;
}

.ue896e {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: -0.21428571428571427rem;
}

.ufb44d {
  display: flex;
  flex-direction: row;
  text-align: center;
}

.trade_tab_item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  color: rgb(255, 255, 255);
  margin-right: 14px;
  line-height: 22px;
  padding: 14px 20px 10px;
  background-color: #32b1b8;
  text-align: center;
  border-radius: 5px 5px 0px 0px;
  box-sizing: border-box;
  cursor: pointer;
}

.textu99b63 {
  font-size: 18px;
}

.trade_tab_item:last-child {
  margin-right: 0;
}

.bread_active {
  background-color: rgb(255, 255, 255);
}

.bread_active2 {
  font-family: "Arial Bold" !important;
  color: #009ea7;
}

.trade_midlle_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
}

.udea11 {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0.35rem 1.42rem;
  position: relative;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.u518ac {
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: 0.4s;
  z-index: 0;
  pointer-events: none;
}

.uebc34 {
  margin-right: 1.4285714285714286rem;
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  font-size: 1.285714rem;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  z-index: 5;
}

.uebc34:last-child {
  margin-right: 0;
}

.tab2_active {
  background-color: rgb(255, 255, 255);
  z-index: 10;
  font-weight: 400;
  font-family: "Arial Bold";
}

.trade_midlle_bottom_cont {
  display: flex;
  width: 100%;
  justify-content: space-around;
  gap: 12px;
}

.trade_midlle_bottom_item {
  height: 100%;
}

.u0c804 {
  border-radius: 5px;
}

.uboa8Fv .submore {
  height: 5rem;
  overflow-y: auto;
  margin-right: 2.142857142857143rem;
}

.submore::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.2);
}

.u91cf9:nth-child(5n + 5) {
  color: #f8f8f6;
  background-color: #81c97a;
}

.u91cf9:nth-child(5n + 4) {
  color: #ffffff;
  background-color: #f867b5;
}

.u91cf9:nth-child(5n + 3) {
  color: #fefefe;
  background-color: #8e86dd;
}

.u91cf9:nth-child(5n + 2) {
  color: #f8f8f6;
  background-color: #ff6a6a;
}

.u0a580 .subsvg {
  transform: rotate(180deg);
}

.back-to-top {
  z-index: 99999;
  position: fixed;
  transition: opacity 0.4s ease-in-out 0s;
  opacity: 1;
  box-sizing: border-box;
  bottom: 10.714285714285714rem;
  right: 1.7857142857142858rem;
  cursor: pointer;
}

.showBackToTop {
  width: 2.857142857142857rem;
  height: 2.857142857142857rem;
  background: #009ea7;
  border-radius: 50%;
  box-shadow: 0rem 0.14285714285714285rem 0.7142857142857143rem 0rem
    rgba(0, 122, 177, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.borderLIne {
  margin: 0 30px;
  padding: 0 30px;
  margin-right: 0px;
  border-right: 1px solid rgba(255, 255, 255, 0.5);
  border-left: 1px solid rgba(255, 255, 255, 0.5);
}

.hsDes,
.hsDestwo {
  font-size: 14px;
  color: #ffffff;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 5rem;
}
.hsDes {
  font-size: 26px;
}
.HsCode {
  font-size: 14px;
  color: #ffffff;
}

.hsDestwo {
  margin-top: 14px;
  font-size: 14px !important;
  color: #ffffff;
}
.u83191center {
  display: flex;
  justify-content: center;
}
.IsSactionActive {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
}
.IsSactionActiveRed {
  color: #f56c6c;
}
.HscodeBorder {
  font-size: 14px;
  color: #ffffff;
  padding-right: 1.42857143rem;
  margin-right: 1.42857143rem;
  border-right: 1px solid rgba(255, 255, 255, 0.5);
}
.Updateyear {
  color: #20f3ff;
}
@media screen and (max-width: 1920px) {
  .ubb08b,
  .u5b01d,
  .uebc34 {
    font-size: 16px;
  }
  .trade_middle_top {
    min-height: 210px;
    padding-left: 52px;
    padding-right: 52px;
  }
  .trade_midlle_bottom {
    padding: 15px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .trade_midlle_bottom_cont {
    gap: 9px;
  }
  .borderLIne {
    margin: 0 22px;
    padding: 0 22px;
  }
  .trade_bottom_cont {
    margin-left: 15px;
    margin-right: 15px;
  }
  .trade_tab_item {
    margin-right: 10px;
    line-height: 18px;
    padding: 10px 15px 7px;
  }

  .textu99b63 {
    font-size: 16px;
  }

  .hsDestwo {
    margin-top: 10px;
    font-size: 12px !important;
  }
  .HsCode {
    font-size: 12px;
  }
  .hsDes {
    font-size: 20px;
  }
  .IsSactionActive {
    width: 24px;
    height: 24px;
  }
  .trade_middle_top {
    padding-top: 15px;
  }
}
@media screen and (max-width: 1439px) {
  .trade_middle_top {
    padding-left: 46px;
    padding-right: 46px;
  }
  .trade_midlle_bottom_cont {
    gap: 8px;
  }
  .borderLIne {
    margin: 0 20px;
    padding: 0 20px;
  }
  .trade_bottom_cont {
    margin-left: 13px;
    margin-right: 13px;
  }
  .trade_midlle_bottom {
    padding: 13px;
    box-shadow: 0px 2px 9px 0px rgba(0, 0, 0, 0.12);
  }
  .trade_tab_item {
    margin-right: 10px;
    line-height: 16px;
    padding: 9px 13px 6px;
  }

  .textu99b63 {
    font-size: 14px;
  }
  .hsDestwo {
    margin-top: 9px;
    font-size: 12px !important;
  }
  .IsSactionActive {
    width: 22px;
    height: 22px;
  }
  .hsDes {
    font-size: 18px;
  }
}
</style>
